<template>
  <div>
    <table :border="border">
      <tbody>
        <template v-for="(tList, index) in tableSetList">
          <BaseTableDetailRow
              :ref="`row_${index}`"
              :key="index"
              :properties="tList"
              :display-item="displayItem"
              :editable="editable"
              :validate-scope="validateScope"
              :site-code="siteCode"
              :custom-cell-style="customCellStyle"
              :highlight-path-list="highlightPathList"
              :highlight-sku-path-list="highlightSkuPathList"
              :is-copied-all="isCopiedAll"
              :is-copied-sku="isCopiedSku" />
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>

import BaseTableDetailRow from '@/components/molecules/BaseTableDetailRow'

export default {
  name: 'BaseTableDetail',
  components: {
    BaseTableDetailRow
  },
  inject: ['parentValidator'],
  props: {
    tableSetList: {
      type: Array,
      required: true,
      default: () => {
        return []
      }
    },
    displayItem: {
      type: Object,
      required: true,
      default: () => {
        return {}
      }
    },
    editable: {
      type: Object,
      default: () => {
        return {}
      }
    },
    border: {
      type: Boolean,
      default: false
    },
    siteCode: {
      type: String,
      default: null
    },
    validateScope: {
      type: String,
      default: null
    },
    customCellStyle: {
      type: Function,
      default: () => {}
    },
    highlightPathList: {
      type: Object,
      default: () => {
        return {}
      }
    },
    highlightSkuPathList: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isCopiedAll: {
      type: Boolean,
      default: false
    },
    isCopiedSku: {
      type: Boolean,
      default: false
    }
  },
  created () {
    this.$validator = this.parentValidator
  },
  methods: {
    focus (path) {
      const targetIndex = this.tableSetList.findIndex((element) => element.properties.find((pro) => pro.path === path))
      if (targetIndex >= 0) {
        this.$refs[`row_${targetIndex}`][0].focus(...[].slice.call(arguments))
      }
    }
  }
}
</script>
